/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butbewilligungbis4Inputs */

const de__field_butbewilligungbis4 = /** @type {(inputs: _Field_Butbewilligungbis4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT-Bewilligung bis`)
};

/**

* @param {_Field_Butbewilligungbis4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butbewilligungbis4 = /** @type {((inputs?: _Field_Butbewilligungbis4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butbewilligungbis4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butbewilligungbis4(inputs)
});
export { _field_butbewilligungbis4 as "_field_BuTBewilligungBis" }